import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import Select from "react-validation/build/select";
import Textarea from "react-validation/build/textarea";
import moment from "moment";
// import { Redirect } from "react-router-dom";
import _ from "lodash";
import DatePicker from "react-datepicker";
import * as validations from "../lib/validations";
import {
  getCommonAll,
  clearUpdate,
  admissionPersonalInfoInsert,
  getCountryStateCity,
  getUserDetailsByUserId,
  getAllAchievements,
  //getAllAdmissionFormConfigurationByFormId,
  getAllProfileLanguages,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  getAllPhysicallyChallengeCategory,
} from "../../actions";
import updateGrid from "../../utils/updateGrid";
import SelectAdvance from "react-select";
import fileToBase64 from "../../utils/fileTobase64";
import AvatarEditor from "react-avatar-editor";
import NoImage from "../../img/no_image.jpg";
import textToCapitalize from "../../utils/textToCapitalize";
import { NotificationManager } from "react-notifications";
import { prefixlist } from "../../utils/enums";
// import { isValid } from "date-fns";
const keys = require("../../config/keys");

class DateOFBirthInput extends Component {
  render() {
    return (
      <label onClick={this.props.onClick} className="ProfiledateInput">
        <input
          value={this.props.value || ""}
          disabled
          className="form-control"
        />
      </label>
    );
  }
}
class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isForeignStudent: false,
      isPhysically: false,
      isMinority: false,
      allAchievementsData: [],
      allLanguagesData: [],
      birthRequired: false,
      showCountryMessage: false,
      showStateMessage: false,
      showCityMessage: false,
      showCACountryMessage: false,
      showCAStateMessage: false,
      showCACityMessage: false,

      showMessage: false,
      showErrLanguages: false,
      ShowErrProfile: false,
      ShowpdfError: false,
      fatherMobileError: false,
      motherMobileError: false,
      mobileErrMsg: "",
      emergencyMobileErrMsg: "",
      fatherMobileErrMsg: "",
      motherMobileErrMsg: "",
    };
  }

  birthDate = (date) => {
    if (date !== null) {
      this.setState({
        birthRequired: false,
      });
    } else {
      this.setState({
        birthRequired: true,
      });
    }
    this.setState({
      dateOfBirth: date,
    });
  };

  issueDate = (date) => {
    this.setState({
      issueDate: date,
    });
  };
  expiryDate = (date) => {
    this.setState({
      expiryDate: date,
    });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onPhysicallyChallenge = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
    if (!e.target.checked) {
      this.setState({
        physicallyChallengeInfo: "",
      });
    }
  };
  setEditorRef = (editor) => (this.editor = editor);
  onSwitchForeignStudent = (e) => {
    this.setState({ [e.target.name]: e.target.checked });

    if (!e.target.checked) {
      this.setState({
        passportNo: "",
        visaDetails: "",
        nameOfCountry: "",
        typeOfVISA: "",
        expiryDate: undefined,
        issueDate: undefined,
      });
    }
  };

  onMinorityChallenge = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  async componentWillMount() {
    this.props.getCommonAll();
    this.props.getCountryStateCity();
    this.props.getAllAchievements();
    this.props.getAllProfileLanguages();
    this.props.getAllPhysicallyChallengeCategory();
    // this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);
    const PromiseArry = [
      this.props.getAchievementsByStudentId(this.props.auth.userId),
      this.props.getLanguageknownsByStudentId(this.props.auth.userId),
      this.props.getUserDetailsByUserId(this.props.auth.userId),
    ];
    await Promise.all(PromiseArry);

    await this.setState({
      // firstName: this.props.userDetails.FirstName,
      // middleName: this.props.userDetails.MiddleName,
      // lastName: this.props.userDetails.LastName,
      prefixId: this.props.userDetails.prefix,
      firstName:
        this.props.userDetails.FirstName +
        " " +
        this.props.userDetails.MiddleName +
        " " +
        this.props.userDetails.LastName,
      genderId: this.props.userDetails.GenderId,
      genderName: this.props.userDetails.Gender,
      dateOfBirth:
        this.props.userDetails.DOB !== null
          ? moment(this.props.userDetails.DOB)
          : undefined,
      email: this.props.userDetails.Email,
      nationality: this.props.userDetails.Nationality,
      religionId: this.props.userDetails.ReligionId,
      casteCategoryId: this.props.userDetails.CasteCategoryId,
      caste: this.props.userDetails.Caste,
      subCaste: this.props.userDetails.SubCaste,
      mobile: this.props.userDetails.StudMobNo,
      emergencyMobileNo: this.props.userDetails.EmergencyMobNo,
      bloodGroupId: this.props.userDetails.BloodGroupId || 0,
      aadharCard: this.props.userDetails.AadharCard || "",
      maritalStatusId: this.props.userDetails.MaritalStatusId || 0,
      isPhysically:
        this.props.userDetails.PhysicallyChallenge === 1 ? true : false,
      physicallyChallengeInfo: this.props.userDetails.PhysicallyChallengeInfo,
      occupation: this.props.userDetails.Occupation || "",

      motherTounge: this.props.userDetails.MotherTounge || "",
      isMinority: this.props.userDetails.IsMinority === 1 ? true : false,

      ProPic: this.props.userDetails.ProPic,
      ProPicEdit:
        this.props.userDetails.ProPic === null ||
        this.props.userDetails.ProPic === undefined
          ? NoImage
          : keys.ServicePath + this.props.userDetails.ProPic,

      address: this.props.userDetails.Address,
      area: this.props.userDetails.Area,
      CountryId: this.props.userDetails.CountryId,
      StateId: this.props.userDetails.StateId,
      CityId: this.props.userDetails.CityId,
      pincode: this.props.userDetails.PinCode,
      phone: this.props.userDetails.Phone,
      correspondenceAddress: this.props.userDetails.CorrespondenceAddress,
      correspondenceArea: this.props.userDetails.CorrespondenceArea,
      correspondenceCountryId: this.props.userDetails.CorrespondenceCountryId,
      correspondenceStateId: this.props.userDetails.CorrespondenceStateId,
      correspondenceCityId: this.props.userDetails.CorrespondenceCityId,
      correspondencePinCode: this.props.userDetails.CorrespondencePinCode,
      correspondencePhone: this.props.userDetails.CorrespondencePhone,
      fatherName: this.props.userDetails.FatherName,
      fatherMobNo: this.props.userDetails.FatherMobNo,
      fatherEmail: this.props.userDetails.FatherEmail,
      motherName: this.props.userDetails.MotherName,
      motherMobNo: this.props.userDetails.MotherMobNo,
      motherEmail: this.props.userDetails.MotherEmail,
      guardianName: this.props.userDetails.GuardianName,
      guardianMobNo: this.props.userDetails.GuardianMobNo,
      guardianEmail: this.props.userDetails.GuardianEmail,
      guardianRelation: this.props.userDetails.GuardianRelation,
      spouseName: this.props.userDetails.SpouseName,
      spouseMobNo: this.props.userDetails.SpouseMobNo,
      spouseEmail: this.props.userDetails.SpouseEmail,
      spouseRelation: this.props.userDetails.SpouseRelation,
      fatherOccupation: this.props.userDetails.FatherOccupation,
      motherOccupation: this.props.userDetails.MotherOccupation,
      guardianOccupation: this.props.userDetails.GuardianOccupation,
      spouseOccupation: this.props.userDetails.SpouseOccupation,
      isForeignStudent:
        this.props.userDetails.IsForeignStudent === 1 ? true : false,
      isSameAbove: this.props.userDetails.IsSameAbove === 1 ? true : false,
      passportNo: this.props.userDetails.PassportNo,
      visaDetails: this.props.userDetails.VisaDetails,
      issueDate:
        this.props.userDetails.IssueDate !== null
          ? moment(this.props.userDetails.IssueDate)
          : undefined,
      expiryDate:
        this.props.userDetails.ExpiryDate !== null
          ? moment(this.props.userDetails.ExpiryDate)
          : undefined,
      nameOfCountry: this.props.userDetails.NameOfCountry,
      typeOfVISA: this.props.userDetails.TypeOfVISA,
      IsFilled: this.props.userDetails.IsFilled,
      allAchievementsData: this.props.achievementByStudent,
      allLanguagesData: this.props.languageKnownByStudent,
    });
  }
  componentDidUpdate() {
    updateGrid(this);
  }

  handleCountryChange = async (selectedOption) => {
    await this.setState({
      CountryId: selectedOption ? selectedOption.value : 0,
      // CountryName: selectedOption ? selectedOption.label : ""
    });

    if (this.state.CountryId === 0) {
      this.setState({ showCountryMessage: true });
    } else {
      this.setState({ showCountryMessage: false });
    }
  };
  handleStateChange = async (selectedOption) => {
    await this.setState({
      StateId: selectedOption ? selectedOption.value : 0,
      // StateName: selectedOption ? selectedOption.label : ""
    });

    if (this.state.StateId === 0) {
      this.setState({ showStateMessage: true });
    } else {
      this.setState({ showStateMessage: false });
    }
  };
  handleCityChange = async (selectedOption) => {
    await this.setState({
      CityId: selectedOption ? selectedOption.value : 0,
      // CityName: selectedOption ? selectedOption.label : ""
    });

    if (this.state.CityId === 0) {
      this.setState({ showCityMessage: true });
    } else {
      this.setState({ showCityMessage: false });
    }
  };
  handleCACountryChange = async (selectedOption) => {
    await this.setState({
      correspondenceCountryId: selectedOption ? selectedOption.value : 0,
      // CountryName: selectedOption ? selectedOption.label : ""
    });
    if (this.state.correspondenceCountryId === 0) {
      this.setState({ showCACountryMessage: true });
    } else {
      this.setState({ showCACountryMessage: false });
    }
  };
  handleCAStateChange = async (selectedOption) => {
    await this.setState({
      correspondenceStateId: selectedOption ? selectedOption.value : 0,
      // StateName: selectedOption ? selectedOption.label : ""
    });
    if (this.state.correspondenceStateId === 0) {
      this.setState({ showCAStateMessage: true });
    } else {
      this.setState({ showCAStateMessage: false });
    }
  };
  handleCACityChange = async (selectedOption) => {
    await this.setState({
      correspondenceCityId: selectedOption ? selectedOption.value : 0,
      // CityName: selectedOption ? selectedOption.label : ""
    });
    if (this.state.correspondenceCityId === 0) {
      this.setState({ showCACityMessage: true });
    } else {
      this.setState({ showCACityMessage: false });
    }
  };

  handleBloodGroupChange = (selectedOption) => {
    var objBloodType = this.props.common.bloodGroups.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objBloodType.length > 0) {
      this.setState({ bloodGroupId: selectedOption.target.value || 0 });
      this.setState({ bloodGroupName: objBloodType[0].Name || "" });
    }
  };
  renderBloodGroup = () => {
    return _.sortBy(this.props.common.bloodGroups, "Name").map((data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Name}
        </option>
      );
    });
  };
  handleCasteCategoryChange = (selectedOption) => {
    var objCastType = this.props.common.casteCategories.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objCastType.length > 0) {
      this.setState({ casteCategoryId: selectedOption.target.value || 0 });
      this.setState({ casteCategoryName: objCastType[0].Name || "" });
    }
  };
  renderCasteCategory = () => {
    return _.sortBy(this.props.common.casteCategories, "Name").map((data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Name}
        </option>
      );
    });
  };
  handleReligionChange = (selectedOption) => {
    var objReligion = this.props.common.religions.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objReligion.length > 0) {
      this.setState({ religionId: selectedOption.target.value || 0 });
      this.setState({ religionName: objReligion[0].ReligionName || "" });
    }
  };
  renderReligionList = () => {
    return _.sortBy(this.props.common.religions, "ReligionName").map((data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.ReligionName}
        </option>
      );
    });
  };
  handleMaritalStatusChange = (selectedOption) => {
    var objMaritalType = this.props.common.maritalStatus.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );

    if (objMaritalType.length > 0) {
      this.setState({ maritalStatusId: selectedOption.target.value || 0 });
      this.setState({ maritalStatusName: objMaritalType[0].Name || "" });
    }
  };
  renderMaritalStatus = () => {
    return _.map(this.props.common.maritalStatus, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Name}
        </option>
      );
    });
  };
  handleGenderChange = (selectedOption) => {
    var objGenderType = this.props.common.gender.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objGenderType.length > 0) {
      this.setState({ genderId: selectedOption.target.value || 0 });
      this.setState({ genderName: objGenderType[0].Name || "" });
    }
  };
  renderGenderGroup = () => {
    return _.map(this.props.common.gender, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Name}
        </option>
      );
    });
  };

  handlePhysicallyChallengedInfoChange = (selectedOption) => {
    this.setState({
      physicallyChallengeInfo: selectedOption.target.value || "",
    });
  };
  renderPhysicallyChallengedInfo() {
    return _.map(this.props.admissionPhysicallychallenge, (data) => {
      return (
        <option key={data.Id} value={data.Name}>
          {data.Name}
        </option>
      );
    });
  }

  handleChangeAsAbove = (e) => {
    this.setState({
      isSameAbove: e.target.checked,
    });
    if (e.target.checked) {
      this.setState({
        correspondenceAddress: this.state.address,
        correspondenceArea: this.state.area,
        correspondenceCountryId: this.state.CountryId,
        correspondenceStateId: this.state.StateId,
        correspondenceCityId: this.state.CityId,
        correspondencePinCode: this.state.pincode,
        correspondencePhone: this.state.phone,
        showCACountryMessage: false,
        showCAStateMessage: false,
        showCACityMessage: false,
      });
    } else {
      this.setState({
        correspondenceAddress: "",
        correspondenceArea: "",
        correspondenceCountryId: "",
        correspondenceStateId: "",
        correspondenceCityId: "",
        correspondencePinCode: "",
        correspondencePhone: "",
      });
    }
  };
  handleFileBrowseChange = (e) => {
    e.persist();
    if (e.target.files.length > 0 && e.target.files[0].size <= 512000) {
      if (e.target.files[0]) {
        fileToBase64(e).then((data) => {
          var CheckExt = data.name.split(".").pop();
          if (
            CheckExt.toLowerCase() === "jpeg" ||
            CheckExt.toLowerCase() === "jpg" ||
            CheckExt.toLowerCase() === "png"
          ) {
            this.setState({
              ProPic: data.file,
              ProPicPath: data.file,
              ProPicName: data.name,
              ShowErrProfile: false,
              ShowpdfError: false,
            });
          } else {
            this.setState({
              ShowpdfError: true,
              ProPic: "",
              ProPicPath: "",
              ProPicName: "",
            });
          }
        });
      }
    } else {
      this.setState({ [e.target.value]: "" });
      NotificationManager.warning("File size should not be more than 512KB");
    }
  };
  // Achievement
  handleAchievementsTypeChange = (event) => {
    this.setState({
      achievementTypeId: parseInt(event.target.selectedIndex, 10),
      achievementType: event.target[event.target.selectedIndex].text,
    });
  };

  handleAreaOfFieldChange = (selectedOption) => {
    var objAreaOfField = this.props.achievementList.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objAreaOfField.length > 0) {
      this.setState({ achievementId: selectedOption.target.value || 0 });
      this.setState({
        achievementName: objAreaOfField[0].Achievement_Name || "",
      });
    }
  };
  renderAreaOfFields = () => {
    return _.sortBy(this.props.achievementList, "Achievement_Name").map(
      (data) => {
        return (
          <option key={data.Id} value={data.Id}>
            {data.Achievement_Name}
          </option>
        );
      }
    );
  };
  addAchievementsData = async (e) => {
    e.preventDefault();
    if (
      this.state.achievementId > 0 &&
      this.state.achievementTypeId > 0 &&
      this.state.specialization !== undefined
    ) {
      var achiventDatas = this.state.allAchievementsData.filter((item) => {
        return (
          item.Specialization.toLowerCase().trim() ===
            this.state.specialization.toLowerCase().trim() &&
          item.AchievementId === parseInt(this.state.achievementId, 10) &&
          item.AchievementTypeId === parseInt(this.state.achievementTypeId, 10)
        );
      });

      if (achiventDatas.length === 0) {
        const achievementsConfig = {
          AchievementId: parseInt(this.state.achievementId, 10),
          AchievementName: this.state.achievementName.trim(),
          AchievementTypeId: this.state.achievementTypeId,
          AchievementType: this.state.achievementType,
          Specialization: textToCapitalize(this.state.specialization.trim()),
        };
        await this.setState({
          allAchievementsData: [
            ...this.state.allAchievementsData.filter((item) => {
              return (
                item.Specialization.toLowerCase().trim() !==
                  this.state.specialization.toLowerCase().trim() ||
                item.AchievementId !== parseInt(this.state.achievementId, 10) ||
                item.AchievementTypeId !==
                  parseInt(this.state.achievementTypeId, 10)
              );
            }),
            achievementsConfig,
          ],
        });
      }
    }
    await this.setState({
      achievementId: 0,
      achievementTypeId: 0,
      specialization: "",
    });
  };
  achievementConfigDelete = (eIndex) => {
    var array = this.state.allAchievementsData;
    // var achieveIndex = array.indexOf();
    array.splice(eIndex, 1);
    this.setState({
      allAchievementsData: array,
      achievementId: 0,
      achievementTypeId: 0,
      specialization: "",
    });
  };

  // Profile Language
  addLanguagesData = async (e) => {
    e.preventDefault();
    if (
      this.state.languageId > 0 &&
      this.state.languageName !== undefined &&
      this.state.speaking > 0 &&
      this.state.reading > 0 &&
      this.state.writing > 0
    ) {
      var languageDatas = this.state.allLanguagesData.filter((item) => {
        return (
          item.LanguageName.toLowerCase().trim() ===
          this.state.languageName.toLowerCase().trim()
        );
      });
      this.setState({ showErrLanguages: false });
      if (languageDatas.length === 0) {
        const languagesConfig = {
          LanguageId: parseInt(this.state.languageId, 10),
          LanguageName: this.state.languageName.trim(),
          Speaking: parseInt(this.state.speaking, 10),
          Reading: parseInt(this.state.reading, 10),
          Writing: parseInt(this.state.writing, 10),
        };
        await this.setState({
          allLanguagesData: [
            ...this.state.allLanguagesData.filter(
              (item) =>
                item.LanguageName.toLowerCase().trim() !==
                this.state.languageName.toLowerCase().trim()
            ),
            languagesConfig,
          ],
        });
      }
    }
  };
  languagesConfigDelete = (eIndex) => {
    var array = this.state.allLanguagesData;
    array.splice(eIndex, 1);

    this.setState({
      allLanguagesData: array,
      languageId: 0,
    });
    if (this.state.allLanguagesData.length === 0) {
      this.setState({ showErrLanguages: true });
    }
  };
  handleLanguagesChange = (selectedOption) => {
    var objLanguage = this.props.profileLanguageList.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objLanguage.length > 0) {
      this.setState({ languageId: selectedOption.target.value || 0 });
      this.setState({
        languageName: objLanguage[0].Language_Name || "",
      });
    }
  };
  renderLanguageList = () => {
    return _.map(this.props.profileLanguageList, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.Language_Name}
        </option>
      );
    });
  };

  validateMobileNos = () => {
    let flagErrMobileNos = {
      mobileErr: 0,
      emergencyMobileErr: 0,
      fatherMobileErr: 0,
      motherMobileErr: 0,
    }

    let mobileErrMsg = "";
    if (this.state.nationality === "Indian" && this.state.mobile.trim().length !== 10) {
      flagErrMobileNos.mobileErr = 1;
      mobileErrMsg = "Mobile must be 10 digits.";
    } else if (this.state.nationality !== "Indian" && (this.state.mobile.trim().length < 7 || this.state.mobile.trim().length > 15)) {
      flagErrMobileNos.mobileErr = 1;
      mobileErrMsg = "Mobile must be between 7 and 15 digits.";
    } else {
      flagErrMobileNos.mobileErr = 0;
      mobileErrMsg = "";
    }

    let emergencyMobileErrMsg = "";
    if (this.state.nationality === "Indian" && this.state.emergencyMobileNo.trim().length !== 10) {
      flagErrMobileNos.emergencyMobileErr = 1;
      emergencyMobileErrMsg = "Mobile must be 10 digits.";
    } else if (this.state.nationality !== "Indian" && (this.state.emergencyMobileNo.trim().length < 7 || this.state.emergencyMobileNo.trim().length > 15)) {
      flagErrMobileNos.emergencyMobileErr = 1;
      emergencyMobileErrMsg = "Mobile must be between 7 and 15 digits.";
    } else {
      flagErrMobileNos.emergencyMobileErr = 0;
      emergencyMobileErrMsg = "";
    }
    
    let fatherMobileErrMsg = "";
    if (this.state.nationality === "Indian" && this.state.fatherMobNo.trim().length !== 10) {
      flagErrMobileNos.fatherMobileErr = 1;
      fatherMobileErrMsg = "Mobile must be 10 digits."
    } else if (this.state.nationality !== "Indian" && (this.state.fatherMobNo.trim().length < 7 || this.state.fatherMobNo.trim().length > 15)) {
      flagErrMobileNos.fatherMobileErr = 1;
      fatherMobileErrMsg = "Mobile must be between 7 and 15 digits.";
    } else {
      flagErrMobileNos.fatherMobileErr = 0;
      fatherMobileErrMsg = "";
    }

    let motherMobileErrMsg = "";
    if (this.state.nationality === "Indian" && this.state.motherMobNo.trim().length !== 10) {
      flagErrMobileNos.motherMobileErr = 1;
      motherMobileErrMsg = "Mobile must be 10 digits."
    } else if (this.state.nationality !== "Indian" && (this.state.motherMobNo.trim().length < 7 || this.state.motherMobNo.trim().length > 15)) {
      flagErrMobileNos.motherMobileErr = 1;
      motherMobileErrMsg = "Mobile must be between 7 and 15 digits."
    } else {
      flagErrMobileNos.motherMobileErr = 0;
      motherMobileErrMsg = "";
    }
    // console.log("flagErrMobileNos:-", flagErrMobileNos)

    this.setState({ mobileErrMsg, emergencyMobileErrMsg, fatherMobileErrMsg, motherMobileErrMsg });

    if (flagErrMobileNos.mobileErr === 1 || flagErrMobileNos.emergencyMobileErr === 1 || flagErrMobileNos.fatherMobileErr === 1 || flagErrMobileNos.motherMobileErr === 1) {
      return 1;
    } else {
      return 0;
    }
  }

  handleSubmit = async (event) => {
    var parentNameFlag = false;
    event.preventDefault();

    if (!this.state.ProPic) {
      this.setState({ ShowErrProfile: true });
    } else {
      this.setState({ ShowErrProfile: false });
    }

    var canvasScaled, imageBase64; //canvas
    if (this.editor) {
      canvasScaled = this.editor.getImageScaledToCanvas().toDataURL();
      await fetch(canvasScaled).then((res) => {
        imageBase64 = res.url;
        this.setState({
          ProPic: imageBase64,
          ProPicPath: imageBase64,
          ProPicName: this.state.ProPicName || this.state.firstName,
        });
      });
    }
    var _flagFather = false,
      _flagMother = false,
      _flagGuardian = false,
      _flagSpouse = false,
      _flagLanguage = false,
      _flagPAddress = false,
      _flagCAddress = false;

    if (this.state.fatherName !== "" && this.state.motherName !== "") {
      parentNameFlag = true;
    }

    if (
      this.state.fatherName !== "" &&
      this.state.fatherMobNo !== "" &&
      this.state.fatherEmail !== "" &&
      this.state.fatherOccupation !== ""
    ) {
      _flagFather = true;
      this.setState({
        showMessage: false,
      });
    }
    if (this.state.allLanguagesData.length > 0) {
      _flagLanguage = true;
    }

    if (
      this.state.motherName !== "" &&
      this.state.motherMobNo !== "" &&
      this.state.motherEmail !== "" &&
      this.state.motherOccupation !== ""
    ) {
      _flagMother = true;
      this.setState({
        showMessage: false,
      });
    }

    if (
      this.state.guardianName !== "" &&
      this.state.guardianMobNo !== "" &&
      this.state.guardianEmail !== "" &&
      this.state.guardianOccupation !== "" &&
      this.state.guardianRelation !== ""
    ) {
      _flagGuardian = true;
      this.setState({
        showMessage: false,
      });
    }

    if (
      this.state.CountryId > 0 &&
      this.state.StateId > 0 &&
      this.state.CityId > 0
    ) {
      _flagPAddress = true;
    }
    if (
      this.state.correspondenceCountryId > 0 &&
      this.state.correspondenceStateId > 0 &&
      this.state.correspondenceCityId > 0
    ) {
      _flagCAddress = true;
    }

    if (
      this.state.spouseName !== "" &&
      this.state.spouseMobNo !== "" &&
      this.state.spouseEmail !== "" &&
      this.state.spouseOccupation !== ""
      // && this.state.spouseRelation !== ""
    ) {
      _flagSpouse = true;
      this.setState({
        showMessage: false,
      });
    }

    var languageIds;
    if (this.state.allLanguagesData.length > 0) {
      languageIds = this.state.allLanguagesData.map((item) => {
        return item.LanguageId;
      });
      this.setState({ showErrLanguages: false });
    } else {
      languageIds = 0;
      this.setState({ showErrLanguages: true });
    }

    const personalInfo = {
      UserId: this.props.auth.userId,
      Prefix: this.state.prefixId,
      FirstName: textToCapitalize(this.state.firstName),
      // MiddleName: textToCapitalize(this.state.middleName),
      MiddleName: "",
      // LastName: textToCapitalize(this.state.lastName),
      LastName: "",
      GenderId: parseInt(this.state.genderId, 10),
      Gender: textToCapitalize(this.state.genderName),
      DOB:
        this.state.dateOfBirth !== undefined
          ? moment(this.state.dateOfBirth).format("YYYY-MM-DD")
          : null,
      Email: this.state.email,
      Nationality: this.state.nationality,
      ReligionId: parseInt(this.state.religionId, 10),
      CasteCategoryId: parseInt(this.state.casteCategoryId, 10),
      Caste: textToCapitalize(this.state.caste),
      SubCaste: textToCapitalize(this.state.subCaste),
      StudMobNo: this.state.mobile,
      EmergencyMobNo: this.state.emergencyMobileNo,
      BloodGroupId: this.state.bloodGroupId
        ? parseInt(this.state.bloodGroupId, 10)
        : null,
      AadharCard: this.state.aadharCard === "" ? null : this.state.aadharCard,
      MaritalStatusId: this.state.maritalStatusId
        ? parseInt(this.state.maritalStatusId, 10)
        : null,
      MaritalStatusName: this.state.maritalStatusName
        ? textToCapitalize(this.state.maritalStatusName) || ""
        : "",
      PhysicallyChallenge: this.state.isPhysically ? 1 : 0,
      PhysicallyChallengeInfo: textToCapitalize(
        this.state.physicallyChallengeInfo
      ),
      Occupation: this.state.occupation
        ? textToCapitalize(this.state.occupation)
        : null,

      MotherTounge: this.state.motherTounge
        ? textToCapitalize(this.state.motherTounge)
        : null,
      IsMinority: this.state.isMinority ? 1 : 0,

      ProPicName: this.state.ProPicName || "",
      ProPic:
        this.props.userDetails.ProPic === this.state.ProPic
          ? null
          : this.state.ProPic,
      ProPicPath: this.state.ProPicPath || null,
      Address: textToCapitalize(this.state.address),
      Area: textToCapitalize(this.state.area),
      CountryId: this.state.CountryId,
      StateId: this.state.StateId,
      CityId: this.state.CityId,
      PinCode: this.state.pincode,
      Phone: this.state.phone,
      CorrespondenceAddress: textToCapitalize(this.state.correspondenceAddress),
      CorrespondenceArea: textToCapitalize(this.state.correspondenceArea),
      CorrespondenceCountryId: this.state.correspondenceCountryId,
      CorrespondenceStateId: this.state.correspondenceStateId,
      CorrespondenceCityId: this.state.correspondenceCityId,
      CorrespondencePinCode: this.state.correspondencePinCode,
      CorrespondencePhone: this.state.correspondencePhone,
      IsSameAbove: this.state.isSameAbove ? 1 : 0,
      FatherName: textToCapitalize(this.state.fatherName),
      FatherMobNo: this.state.fatherMobNo,
      FatherEmail: this.state.fatherEmail,
      MotherName: textToCapitalize(this.state.motherName),
      MotherMobNo: this.state.motherMobNo,
      MotherEmail: this.state.motherEmail,
      GuardianName: textToCapitalize(this.state.guardianName),
      GuardianMobNo: this.state.guardianMobNo,
      GuardianEmail: this.state.guardianEmail,
      GuardianRelation: this.state.guardianRelation,
      SpouseName: textToCapitalize(this.state.spouseName),
      SpouseMobNo: this.state.spouseMobNo,
      SpouseEmail: this.state.spouseEmail,
      SpouseRelation: textToCapitalize(this.state.spouseRelation),
      FatherOccupation: textToCapitalize(this.state.fatherOccupation),
      MotherOccupation: textToCapitalize(this.state.motherOccupation),
      GuardianOccupation: textToCapitalize(this.state.guardianOccupation),
      SpouseOccupation: textToCapitalize(this.state.spouseOccupation),
      IsForeignStudent: this.state.isForeignStudent ? 1 : 0,
      PassportNo: this.state.passportNo,
      VisaDetails: textToCapitalize(this.state.visaDetails),
      IssueDate:
        this.state.issueDate !== undefined
          ? moment(this.state.issueDate).format("YYYY-MM-DD")
          : null,
      ExpiryDate:
        this.state.expiryDate !== undefined
          ? moment(this.state.expiryDate).format("YYYY-MM-DD")
          : null,
      NameOfCountry: textToCapitalize(this.state.nameOfCountry),
      TypeOfVISA: textToCapitalize(this.state.typeOfVISA),
      Achievements: this.state.allAchievementsData,
      Languages: this.state.allLanguagesData,
      LanguageIds: languageIds.toString(),
      IsFilled: 1,
      IsActive: 1,
      IsDelete: false,
      CreatedBy: this.props.auth.userId,
      UpdatedBy: this.props.auth.userId,
      Id: this.state.Id || 0,
    };

    // if (
    //   (_flagFather || _flagMother || _flagGuardian || _flagSpouse) &&
    //   _flagLanguage &&
    //   _flagPAddress &&
    //   _flagCAddress &&
    //   parentNameFlag &&
    //   this.state.dateOfBirth &&
    //   (this.state.ProPicPath || this.state.ProPic)
    // )

    const flagMobileErr = this.validateMobileNos();

    if (
      // (_flagGuardian || _flagSpouse) &&
      _flagFather &&
      _flagMother &&
      _flagLanguage &&
      _flagPAddress &&
      _flagCAddress &&
      // parentNameFlag &&
      this.state.dateOfBirth &&
      (this.state.ProPicPath || this.state.ProPic)
      && flagMobileErr === 0
    ) {
      this.props.admissionPersonalInfoInsert(personalInfo);
      this.setState({
        showMessage: false,
        showErrLanguages: false,
        showCountryMessage: false,
        showStateMessage: false,
        showCityMessage: false,
        showCACountryMessage: false,
        showCAStateMessage: false,
        showCACityMessage: false,
        birthRequired: false,
      });
    } else {
      // if (!(_flagFather || _flagMother || _flagGuardian || _flagSpouse ) || !parentNameFlag) {
      if (
        !(_flagGuardian || _flagSpouse) ||
        !parentNameFlag ||
        _flagFather ||
        _flagMother
      ) {
        if (!_flagFather || !_flagMother) {
          NotificationManager.warning("Parent Details missing");
          this.setState({
            showMessage: true,
          });
        }
      } else {
        this.setState({
          showMessage: false,
        });
      }

      if (!this.state.dateOfBirth) {
        this.setState({
          birthRequired: true,
        });
      }
      if (!this.state.CountryId > 0) {
        this.setState({
          showCountryMessage: true,
        });
      }
      if (!this.state.StateId > 0) {
        this.setState({
          showStateMessage: true,
        });
      }
      if (!this.state.CityId > 0) {
        this.setState({
          showCityMessage: true,
        });
      }
      if (!this.state.correspondenceCountryId > 0) {
        this.setState({
          showCACountryMessage: true,
        });
      }
      if (!this.state.correspondenceStateId > 0) {
        this.setState({
          showCAStateMessage: true,
        });
      }
      if (!this.state.correspondenceCityId > 0) {
        this.setState({
          showCACityMessage: true,
        });
      }
    }
  };

  handlePrefixChange = (selectedOption) => {
    this.setState({ prefixId: parseInt(selectedOption.target.value) });
  };

  render() {
    // if (this.props.update.redirectTab) {
    //   return (
    //     <Redirect
    //       to={`/Account/StudentAccount/AdmissionForm/2/${this.props.FormId}`}
    //     />
    //   );
    // }

    return (
      <div className="userDashboard container">
        <div className="main-bg">
          <Form
            onSubmit={this.handleSubmit.bind(this)}
            ref={(c) => {
              this.form = c;
            }}
            className="textTransCapitalize"
          >
            <p className="text-center mb-0">
              Fields marked with asterisk ( <label className="required" /> ) are
              mandatory
            </p>
            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 7
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12">
                <h4 className="page-title sub-title">Student Details</h4>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-10">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Prefix</label>

                          <Select
                            className="form-control"
                            id="PrefixId"
                            validations={[validations.requiredSelect]}
                            name="PrefixId"
                            value={this.state.prefixId}
                            label="Prefix"
                            onChange={this.handlePrefixChange}
                          >
                            <option value="0">-- Select --</option>
                            {_.uniqBy(prefixlist, "Id").map((item) => {
                              return (
                                <option value={item.Id}>{item.Name}</option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-9 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Full Name</label>
                          <Input
                            type="text"
                            className="form-control"
                            id="firstName"
                            value={this.state.firstName || ""}
                            validations={[validations.required]}
                            name="firstName"
                            label="First Name"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">First Name</label>
                          <Input
                            type="text"
                            className="form-control"
                            id="firstName"
                            value={this.state.firstName || ""}
                            validations={[validations.required]}
                            name="firstName"
                            label="First Name"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Middle Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="middleName"
                            value={this.state.middleName || ""}
                            name="middleName"
                            label="Middle Name"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Last Name</label>
                          <Input
                            type="text"
                            className="form-control"
                            id="lastName"
                            value={this.state.lastName || ""}
                            validations={[validations.required]}
                            name="lastName"
                            label="Last Name"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Gender</label>
                          <Select
                            onChange={this.handleGenderChange}
                            id="genderId"
                            name="genderId"
                            className="form-control"
                            value={this.state.genderId || 0}
                            validations={[validations.requiredSelect]}
                            label="Gender"
                          >
                            <option value="0">Select Gender</option>
                            {this.renderGenderGroup()}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">DOB</label>
                          <DatePicker
                            selected={this.state.dateOfBirth}
                            onChange={this.birthDate}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            dateFormat={this.props.systemConfig.DateFormat}
                            // maxDate={moment().subtract(17, "years")}
                            maxDate={moment(
                              `${
                                this.props.admissionConfiguration.length > 0
                                  ? this.props.admissionConfiguration[0].AyName.substring(
                                      0,
                                      this.props.admissionConfiguration[0].AyName.indexOf(
                                        "-"
                                      )
                                    )
                                  : moment().format("YYYY")
                              }1231`
                            ).subtract(17, "years")}
                            yearDropdownItemNumber={17}
                            scrollableYearDropdown
                            placeholderText="DD/MM/YYYY"
                            validations={[validations.required]}
                            customInput={<DateOFBirthInput />}
                          />
                          {this.state.birthRequired && (
                            <span className="require_field">
                              Date OF Birth is Required
                            </span>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" style={{display:"none"}}>
                        <div className="form-group">
                          <label className="required">Blood Group</label>
                          <Select
                            onChange={this.handleBloodGroupChange}
                            id="bloodGroupId"
                            name="bloodGroupId"
                            className="form-control"
                            value={this.state.bloodGroupId || 0}
                            validations={[validations.requiredSelect]}
                            label="Blood Group"
                          >
                            <option value="0">Select Blood Group</option>

                            {this.renderBloodGroup()}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" style={{display:"none"}}>
                        <div className="form-group">
                          <label className="required">Marital Status</label>
                          <Select
                            className="form-control"
                            id="maritalStatusId"
                            validations={[validations.requiredSelect]}
                            value={this.state.maritalStatusId || 0}
                            name="maritalStatusId"
                            label="Marital Status"
                            onChange={this.handleMaritalStatusChange}
                          >
                            <option value="0">Select Marital Status</option>
                            {this.renderMaritalStatus()}
                          </Select>
                        </div>
                      </div> */}
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Nationality</label>
                          <select
                            className="form-control"
                            id="nationality"
                            name="nationality"
                            value={this.state.nationality || ""}
                            label="Nationality"
                            onChange={this.onInputChange}
                          >
                            <option value="0">Select Nationality</option>
                            <option>Indian</option>
                            <option>NRI</option>
                            <option>PIO</option>
                            <option>Foreigner</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Religion</label>
                          <Select
                            onChange={this.handleReligionChange}
                            id="religionId"
                            name="religionId"
                            className="form-control"
                            validations={[validations.requiredSelect]}
                            value={this.state.religionId || 0}
                            label="Religion"
                          >
                            <option value="0">Select Religion</option>

                            {this.renderReligionList()}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Caste Category</label>
                          <Select
                            onChange={this.handleCasteCategoryChange}
                            id="casteCategoryId"
                            name="casteCategoryId"
                            className="form-control"
                            validations={[validations.requiredSelect]}
                            value={this.state.casteCategoryId || 0}
                            label="Caste Category"
                          >
                            <option value="0">Select CasteCategory</option>
                            {this.renderCasteCategory()}
                          </Select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Caste</label>
                          <input
                            type="text"
                            className="form-control"
                            id="caste"
                            value={this.state.caste || ""}
                            name="caste"
                            label="Caste"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Sub-Caste</label>
                          <input
                            type="text"
                            className="form-control"
                            id="subCaste"
                            value={this.state.subCaste || ""}
                            name="subCaste"
                            label="SubCaste"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Email</label>
                          <Input
                            type="email"
                            label="Email"
                            className="form-control"
                            id="email"
                            value={this.state.email || ""}
                            validations={[
                              validations.required,
                              validations.email,
                            ]}
                            disabled={this.state.email ? true : false}
                            name="email"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">Mobile</label>
                          <Input
                            type="number"
                            className="form-control"
                            id="mobile"
                            value={this.state.mobile || ""}
                            disabled={this.state.mobile ? true : false}
                            // validations={
                            //   ([validations.required], [validations.minLength])
                            // }
                            validations={
                              ([validations.required])
                            }
                            name="mobile"
                            label="Mobile"
                            onChange={this.onInputChange}
                          />
                          {this.state.mobileErrMsg.length > 0 ? (
                            <span className="require_field">
                              {this.state.mobileErrMsg}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label className="required">
                            Emergency Mobile No.
                          </label>
                          <Input
                            type="number"
                            className="form-control"
                            id="emergencyMobileNo"
                            value={this.state.emergencyMobileNo || ""}
                            // validations={
                            //   ([validations.required], [validations.minLength])
                            // }
                            validations={
                              ([validations.required])
                            }
                            name="emergencyMobileNo"
                            label="Emergency Mobile No."
                            onChange={this.onInputChange}
                          />
                          {this.state.emergencyMobileErrMsg.length > 0 ? (
                            <span className="require_field">
                              {this.state.emergencyMobileErrMsg}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" style={{display:"none"}}>
                        <div className="form-group">
                          <label>Aadhar No.</label>
                          <input
                            type="number"
                            className="form-control"
                            id="aadharCard"
                            value={this.state.aadharCard || ""}
                            name="aadharCard"
                            label="Aadhar No."
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div> */}

                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Physically Challenged?</label>
                          <br />
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={this.state.isPhysically ? true : false}
                              name="isPhysically"
                              onChange={this.onPhysicallyChallenge}
                            />
                            <span className="slider round" />
                          </label>
                        </div>
                      </div>
                      {this.state.isPhysically === true && (
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Physically Challenged Info</label>
                            <select
                              className="form-control"
                              id="physicallyChallengeInfo"
                              name="physicallyChallengeInfo"
                              value={this.state.physicallyChallengeInfo || ""}
                              label="Physically Challenged Info"
                              onChange={
                                this.handlePhysicallyChallengedInfoChange
                              }
                            >
                              <option value="0">
                                Select Physically Challenged Info
                              </option>
                              {this.renderPhysicallyChallengedInfo()}
                            </select>
                          </div>
                        </div>
                      )}

                      {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" style={{display:"none"}}>
                        <div className="form-group">
                          <label>Occupation</label>
                          <input
                            type="text"
                            className="form-control"
                            id="occupation"
                            value={this.state.occupation || ""}
                            name="occupation"
                            label="Occupation"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12" style={{display:"none"}}>
                        <div className="form-group">
                          <label>Mother Tongue</label>
                          <input
                            type="text"
                            className="form-control"
                            id="motherTounge"
                            value={this.state.motherTounge || ""}
                            name="motherTounge"
                            label="Mother Tongue"
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <label>Minority?</label>
                          <br />
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={this.state.isMinority ? true : false}
                              name="isMinority"
                              onChange={this.onMinorityChallenge} //Minority
                            />
                            <span className="slider round" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="user_photo thumbnailUser">
                      <label className="required">ProfilePicture</label>

                      {this.state.ProPicPath && (
                        <div>
                          <AvatarEditor
                            ref={this.setEditorRef}
                            image={this.state.ProPicPath || NoImage}
                            width={160}
                            height={160}
                            border={0}
                            color={[255, 255, 255, 0.6]} // RGBA
                            scale={this.state.scaleImage}
                            rotate={0}
                            // className="img-thumbnail"
                          />
                          <div className="photoslidecontainer">
                            <input
                              type="range"
                              min="1"
                              max="5"
                              value={this.state.scaleImage}
                              onChange={(e) => {
                                this.setState({
                                  scaleImage: e.target.value,
                                });
                              }}
                              className="photoslider"
                              id="myRange"
                            />
                          </div>
                        </div>
                      )}
                      {!this.state.ProPicPath && (
                        <img
                          src={
                            this.state.ProPicEdit ||
                            this.state.ProPicPath ||
                            NoImage
                          }
                          alt="profile"
                          // className="img-thumbnail"
                        />
                      )}
                      <center>
                        <div className="upload-btn-wrapper">
                          <button className="btn">Upload a file </button>
                          <input
                            type="file"
                            name="ProPicPath"
                            className="form-control-file"
                            id="ProPicPath"
                            aria-describedby="fileHelp"
                            accept="image/x-png,image/gif,image/jpeg"
                            onChange={this.handleFileBrowseChange.bind()}
                            // ref={c => {
                            //   this.ProPicPath = c;
                            // }}
                            label="ProPicPath"
                            //onFocus={this.removeApiError}
                            // validations={
                            //   this.state.ProPicPath === null
                            //     ? [validations.required]
                            //     : []
                            // }
                          />
                          {this.state.ShowErrProfile && (
                            <span className="require_field">
                              ProfilePicture is Required
                            </span>
                          )}
                          {this.state.ShowpdfError && (
                            <span className="require_field">
                              Only JPG,JPEG and PNG files are allowed.
                            </span>
                          )}
                        </div>
                      </center>
                      <span
                        style={{
                          color: "red",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        File size should not be more than 512KB
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 8
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12 ">
                <hr />
                <h4 className="page-title sub-title">Permanent Address</h4>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">Permanent Address</label>
                      <Textarea
                        type="text"
                        rows="1"
                        className="form-control"
                        id="address"
                        name="address"
                        validations={[validations.required]}
                        label="Permanent Address"
                        value={this.state.address || ""}
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Area</label>
                      <input
                        type="text"
                        className="form-control"
                        id="area"
                        value={this.state.area || ""}
                        name="area"
                        label="Area"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">Country</label>
                      <SelectAdvance
                        validations={[validations.required]}
                        onChange={this.handleCountryChange}
                        id="country"
                        name="CountryId"
                        value={this.state.CountryId}
                        label="Country"
                        options={_.uniqBy(
                          this.props.countryStateCity,
                          "CountryId"
                        ).map((item) => {
                          return {
                            value: item.CountryId,
                            label: item.Country,
                          };
                        })}
                      />
                      {this.state.showCountryMessage && (
                        <span className="require_field">
                          Country is Required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">State</label>
                      <SelectAdvance
                        onChange={this.handleStateChange}
                        id="state"
                        name="StateId"
                        value={this.state.StateId}
                        label="State"
                        validations={[validations.required]}
                        options={_.uniqBy(
                          this.props.countryStateCity,
                          "StateId"
                        )
                          .map((item) => {
                            return {
                              value: item.StateId,
                              label: item.State,
                              countryId: item.CountryId,
                            };
                          })
                          .filter(
                            ({ countryId }) =>
                              countryId === this.state.CountryId
                          )}
                      />
                      {this.state.showStateMessage && (
                        <span className="require_field">State is Required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">City</label>
                      <SelectAdvance
                        onChange={this.handleCityChange}
                        validations={[validations.required]}
                        id="city"
                        name="CityId"
                        value={this.state.CityId}
                        label="City"
                        options={_.uniqBy(this.props.countryStateCity, "CityId")
                          .map((item) => {
                            return {
                              value: item.CityId,
                              label: item.City,
                              stateId: item.StateId,
                            };
                          })
                          .filter(
                            ({ stateId }) => stateId === this.state.StateId
                          )}
                      />
                      {this.state.showCityMessage && (
                        <span className="require_field">City is Required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">Pin Code</label>
                      <Input
                        type="number"
                        className="form-control"
                        id="pincode"
                        value={this.state.pincode || ""}
                        name="pincode"
                        validations={[validations.required]}
                        label="Pin Code"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Phone</label>
                      <input
                        type="number"
                        className="form-control"
                        id="phone"
                        value={this.state.phone || ""}
                        name="phone"
                        label="Phone"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>{" "}
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 9
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12 form-group">
                <hr />
                <h4
                  className="d-inline-block page-title sub-title"
                  style={{ marginRight: "10px" }}
                >
                  Correspondence Address
                </h4>
                <input
                  type="checkbox"
                  id="isSameAbove"
                  name="isSameAbove"
                  checked={this.state.isSameAbove ? true : false}
                  onChange={this.handleChangeAsAbove}
                />
                <label className="checkbox-inline" htmlFor="isSameAbove">
                  <strong>Same as Above</strong>
                </label>
              </div>
              {this.state.isSameAbove ? (
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">
                          Correspondence Address
                        </label>
                        <Textarea
                          type="text"
                          rows="1"
                          className="form-control"
                          id="address"
                          name="address"
                          validations={[validations.required]}
                          label="Permanent Address"
                          disabled={this.state.isSameAbove ? true : false}
                          value={this.state.address || ""}
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Area</label>
                        <input
                          type="text"
                          className="form-control"
                          id="area"
                          value={this.state.area || ""}
                          name="area"
                          label="Area"
                          disabled={this.state.isSameAbove ? true : false}
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Country</label>
                        <SelectAdvance
                          validations={[validations.required]}
                          onChange={this.handleCountryChange}
                          id="country"
                          name="CountryId"
                          value={this.state.CountryId}
                          label="Country"
                          disabled={this.state.isSameAbove ? true : false}
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "CountryId"
                          ).map((item) => {
                            return {
                              value: item.CountryId,
                              label: item.Country,
                            };
                          })}
                        />
                        {this.state.showCountryMessage && (
                          <span className="require_field">
                            Country is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">State</label>
                        <SelectAdvance
                          onChange={this.handleStateChange}
                          id="state"
                          name="StateId"
                          value={this.state.StateId}
                          label="State"
                          disabled={this.state.isSameAbove ? true : false}
                          validations={[validations.required]}
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "StateId"
                          )
                            .map((item) => {
                              return {
                                value: item.StateId,
                                label: item.State,
                                countryId: item.CountryId,
                              };
                            })
                            .filter(
                              ({ countryId }) =>
                                countryId === this.state.CountryId
                            )}
                        />
                        {this.state.showStateMessage && (
                          <span className="require_field">
                            State is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">City</label>
                        <SelectAdvance
                          onChange={this.handleCityChange}
                          validations={[validations.required]}
                          id="city"
                          name="CityId"
                          value={this.state.CityId}
                          label="City"
                          disabled={this.state.isSameAbove ? true : false}
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "CityId"
                          )
                            .map((item) => {
                              return {
                                value: item.CityId,
                                label: item.City,
                                stateId: item.StateId,
                              };
                            })
                            .filter(
                              ({ stateId }) => stateId === this.state.StateId
                            )}
                        />
                        {this.state.showCityMessage && (
                          <span className="require_field">
                            City is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Pin Code</label>
                        <Input
                          type="number"
                          className="form-control"
                          id="pincode"
                          value={this.state.pincode || ""}
                          name="pincode"
                          validations={[validations.required]}
                          label="Pin Code"
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Phone</label>
                        <input
                          type="number"
                          className="form-control"
                          id="phone"
                          value={this.state.phone || ""}
                          name="phone"
                          label="Phone"
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Correspondence Address</label>
                        <textarea
                          type="text"
                          rows="1"
                          className="form-control"
                          id="correspondenceAddress"
                          name="correspondenceAddress"
                          label="Correspondence Address"
                          value={this.state.correspondenceAddress || ""}
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Area</label>
                        <input
                          type="text"
                          className="form-control"
                          id="correspondenceArea"
                          value={this.state.correspondenceArea || ""}
                          name="correspondenceArea"
                          label="Area"
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">Country</label>
                        <SelectAdvance
                          onChange={this.handleCACountryChange}
                          id="correspondenceCountryId"
                          name="correspondenceCountryId"
                          value={this.state.correspondenceCountryId}
                          label="Country"
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "CountryId"
                          ).map((item) => {
                            return {
                              value: item.CountryId,
                              label: item.Country,
                            };
                          })}
                          disabled={this.state.isSameAbove ? true : false}
                        />

                        {this.state.showCACountryMessage && (
                          <span className="require_field">
                            Country is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">State</label>
                        <SelectAdvance
                          onChange={this.handleCAStateChange}
                          id="correspondenceStateId"
                          name="correspondenceStateId"
                          value={this.state.correspondenceStateId}
                          label="State"
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "StateId"
                          )
                            .map((item) => {
                              return {
                                value: item.StateId,
                                label: item.State,
                                countryId: item.CountryId,
                              };
                            })
                            .filter(
                              ({ countryId }) =>
                                countryId === this.state.correspondenceCountryId
                            )}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                        {this.state.showCAStateMessage && (
                          <span className="require_field">
                            State is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">City</label>
                        <SelectAdvance
                          onChange={this.handleCACityChange}
                          id="correspondenceCityId"
                          name="correspondenceCityId"
                          value={this.state.correspondenceCityId}
                          label="City"
                          options={_.uniqBy(
                            this.props.countryStateCity,
                            "CityId"
                          )
                            .map((item) => {
                              return {
                                value: item.CityId,
                                label: item.City,
                                stateId: item.StateId,
                              };
                            })
                            .filter(
                              ({ stateId }) =>
                                stateId === this.state.correspondenceStateId
                            )}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                        {this.state.showCACityMessage && (
                          <span className="require_field">
                            City is Required
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label className="required">PinCode</label>
                        <Input
                          type="number"
                          className="form-control"
                          id="correspondencePinCode"
                          value={this.state.correspondencePinCode || ""}
                          validations={[validations.required]}
                          name="correspondencePinCode"
                          label="Pincode"
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>Phone</label>
                        <input
                          type="number"
                          className="form-control"
                          id="correspondencePhone"
                          value={this.state.correspondencePhone || ""}
                          name="correspondencePhone"
                          label="Phone"
                          onChange={this.onInputChange}
                          disabled={this.state.isSameAbove ? true : false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 10
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12 ">
                <hr />
                <h4 className="page-title sub-title">Family Details</h4>
                <span
                  className="require_field mb-3 ml-2"
                  style={{ color: "black" }}
                >
                  {/* Please enter at least one of the family member details */}
                </span>
              </div>
              <div className="col-lg-12">
                <div className="table-responsive mb-2">
                  <table className="table table-bordered qulification-table fam-details mb-2">
                    <thead>
                      <tr>
                        <th scope="col" className="align-middle" />
                        <th scope="col" className="align-middle">
                          Name
                        </th>
                        <th scope="col" className="align-middle">
                          Mobile No
                        </th>
                        <th scope="col" className="align-middle">
                          Email
                        </th>
                        <th scope="col" className="align-middle">
                          Occupation
                        </th>
                        <th scope="col" className="align-middle">
                          Relation
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="align-middle">
                          {" "}
                          <label className="required">Father</label>
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="fatherName"
                            value={this.state.fatherName || ""}
                            name="fatherName"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          {/* <input
                            type="number"
                            className="form-control"
                            id="fatherMobNo"
                            value={this.state.fatherMobNo || ""}
                            name="fatherMobNo"
                            onChange={this.onInputChange}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length > 9 &&
                                parseInt(e.key)
                              ) {
                                if (e.key !== "Backspace") {
                                  e.preventDefault();
                                }
                                this.setState({ fatherMobileError: true });
                              } else {
                                this.setState({ fatherMobileError: false });
                              }

                              if (
                                e.key === "e" ||
                                e.key === "+" ||
                                e.key === "-" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {this.state.fatherMobileError && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Mobile number should not be more than 10 digits
                            </span>
                          )} */}
                          <input
                            type="number"
                            className="form-control"
                            id="fatherMobNo"
                            value={this.state.fatherMobNo || ""}
                            name="fatherMobNo"
                            onChange={this.onInputChange}
                          />
                          {this.state.fatherMobileErrMsg.length > 0 ? (
                            <span className="require_field">
                              {this.state.fatherMobileErrMsg}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="align-middle">
                          <input
                            type="email"
                            className="form-control"
                            id="fatherEmail"
                            value={this.state.fatherEmail || ""}
                            name="fatherEmail"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="fatherOccupation"
                            value={this.state.fatherOccupation || ""}
                            name="fatherOccupation"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td />
                      </tr>
                      <tr>
                        <td className="align-middle">
                          {" "}
                          <label className="required">Mother</label>
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="motherName"
                            value={this.state.motherName || ""}
                            name="motherName"
                            label="Mother Name"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          {/* <input
                            type="number"
                            className="form-control"
                            id="motherMobNo"
                            value={this.state.motherMobNo || ""}
                            name="motherMobNo"
                            onChange={this.onInputChange}
                            onKeyDown={(e) => {
                              if (e.target.value.length > 9) {
                                if (e.key !== "Backspace") {
                                  e.preventDefault();
                                }

                                this.setState({ motherMobileError: true });
                              } else {
                                this.setState({ motherMobileError: false });
                              }
                            }}
                          />
                          {this.state.motherMobileError && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Mobile number should not be more than 10 digits{" "}
                            </span>
                          )} */}
                          <input
                            type="number"
                            className="form-control"
                            id="motherMobNo"
                            value={this.state.motherMobNo || ""}
                            name="motherMobNo"
                            onChange={this.onInputChange}
                          />
                          {this.state.motherMobileErrMsg.length > 0 ? (
                            <span className="require_field">
                              {this.state.motherMobileErrMsg}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td className="align-middle">
                          <input
                            type="email"
                            className="form-control"
                            id="motherEmail"
                            value={this.state.motherEmail || ""}
                            name="motherEmail"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="motherOccupation"
                            value={this.state.motherOccupation || ""}
                            name="motherOccupation"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td />
                      </tr>
                      <tr>
                        <td className="align-middle">Guardian</td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="guardianName"
                            value={this.state.guardianName || ""}
                            name="guardianName"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="number"
                            className="form-control"
                            id="guardianMobNo"
                            value={this.state.guardianMobNo || ""}
                            name="guardianMobNo"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="email"
                            className="form-control"
                            id="guardianEmail"
                            value={this.state.guardianEmail || ""}
                            name="guardianEmail"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="guardianOccupation"
                            value={this.state.guardianOccupation || ""}
                            name="guardianOccupation"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="guardianRelation"
                            value={this.state.guardianRelation || ""}
                            name="guardianRelation"
                            onChange={this.onInputChange}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="align-middle">Spouse</td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="spouseName"
                            value={this.state.spouseName || ""}
                            name="spouseName"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="number"
                            className="form-control"
                            id="spouseMobNo"
                            value={this.state.spouseMobNo || ""}
                            name="spouseMobNo"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="email"
                            className="form-control"
                            id="spouseEmail"
                            value={this.state.spouseEmail || ""}
                            name="spouseEmail"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          <input
                            type="text"
                            className="form-control"
                            id="spouseOccupation"
                            value={this.state.spouseOccupation || ""}
                            name="spouseOccupation"
                            onChange={this.onInputChange}
                          />
                        </td>
                        <td className="align-middle">
                          {/* <input
                            type="text"
                            className="form-control"
                            id="spouseRelation"
                            value={this.state.spouseRelation || ""}
                            name="spouseRelation"
                            onChange={this.onInputChange}
                          /> */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {this.state.showMessage && (
                    // <span className="require_field mb-3">
                    //    Please enter at least one of the family member details
                    // </span>
                    <span className="require_field mb-3">
                      Please enter the family member details
                    </span>
                  )}
                </div>
              </div>
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 11
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12">
                <h4 className="page-title sub-title">Achievements (If any)</h4>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Area/Field of</label>
                      <select
                        onChange={this.handleAreaOfFieldChange}
                        id="achievementId"
                        name="achievementId"
                        className="form-control"
                        value={this.state.achievementId || 0}
                        //validations={[validations.requiredSelect]}
                        label="Area/Field of"
                      >
                        <option value="0">Select Area/Field</option>
                        {this.renderAreaOfFields()}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Achievements Level</label>
                      <select
                        onChange={this.handleAchievementsTypeChange.bind(this)}
                        id="achievementTypeId"
                        name="achievementTypeId"
                        className="form-control"
                        value={this.state.achievementTypeId || 0}
                        //validations={[validations.requiredSelect]}
                        label="Achievements Level"
                      >
                        <option value="0">Select Achievements Level</option>
                        <option value="1">Taluqa </option>
                        <option value="2">District </option>
                        <option value="3">State </option>
                        <option value="4">National </option>
                        <option value="5">International </option>
                        <option value="6">College</option>
                        <option value="7">University </option>
                        <option value="8">Others</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Specific Achievement Details</label>
                      <textarea
                        type="text"
                        rows="1"
                        className="form-control"
                        id="specialization"
                        name="specialization"
                        label="Specific Achievement Details"
                        value={this.state.specialization || ""}
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 flexMiddel">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addAchievementsData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table table-bordered qulification-table">
                        <thead className="table-light">
                          <tr>
                            <th className="align-middle">Area/Field of</th>
                            <th className="align-middle">Achievements Level</th>
                            <th className="align-middle">
                              Specific Achievement Details
                            </th>
                            <th width="50px" className="align-middle">
                              Remove
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.allAchievementsData.map(
                            (achievement, index) => {
                              return (
                                achievement.AchievementName !== undefined &&
                                  achievement.AchievementName !== "",
                                achievement.AchievementType !== undefined &&
                                  achievement.AchievementType !== "",
                                achievement.Specialization !== undefined &&
                                achievement.Specialization !== "" ? (
                                  <tr key={index}>
                                    <td className="align-middle">
                                      {achievement.AchievementName}
                                    </td>
                                    <td className="align-middle">
                                      {achievement.AchievementType}
                                    </td>
                                    <td className="align-middle">
                                      {achievement.Specialization}
                                    </td>
                                    <td className="text-center align-middle">
                                      <button
                                        className="btn btn-xs btn-danger theme-btn"
                                        onClick={this.achievementConfigDelete.bind(
                                          this,
                                          index
                                        )}
                                        type="button"
                                      >
                                        <i className="fa fa-trash" />
                                      </button>
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 12
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12 ">
                <h4 className="page-title sub-title">Languages Known</h4>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">Languages</label>
                      <select
                        onChange={this.handleLanguagesChange}
                        id="languageId"
                        name="languageId"
                        className="form-control"
                        value={this.state.languageId || 0}
                        label="Language"
                        //validations={[validations.requiredSelect]}
                      >
                        <option value="0">Select Language</option>
                        {this.renderLanguageList()}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 custom-rating">
                    <center>
                      <label>Speaking</label>
                      <fieldset className="rating">
                        <input
                          type="radio"
                          id={"star3"}
                          name={"speaking"}
                          value="3"
                          radioGroup={"speaking"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star3"}
                          title="Excellent"
                        />

                        <input
                          type="radio"
                          id={"star2"}
                          name={"speaking"}
                          value="2"
                          radioGroup={"speaking"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star2"}
                          title="Good"
                        />

                        <input
                          type="radio"
                          id={"star1"}
                          name={"speaking"}
                          value="1"
                          radioGroup={"speaking"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star1"}
                          title="Fair"
                        />
                      </fieldset>
                    </center>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 custom-rating">
                    <center>
                      <label>Reading</label>
                      <fieldset className="rating">
                        <input
                          type="radio"
                          id={"star4"}
                          name={"reading"}
                          value="3"
                          radioGroup={"reading"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star4"}
                          title="Excellent"
                        />

                        <input
                          type="radio"
                          id={"star5"}
                          name={"reading"}
                          value="2"
                          radioGroup={"reading"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star5"}
                          title="Good"
                        />

                        <input
                          type="radio"
                          id={"star6"}
                          name={"reading"}
                          value="1"
                          radioGroup={"reading"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star6"}
                          title="Fair"
                        />
                      </fieldset>
                    </center>
                  </div>
                  <div className="col-lg-2 col-md-3 col-sm-12 custom-rating">
                    <center>
                      <label>Writing</label>
                      <fieldset className="rating">
                        <input
                          type="radio"
                          id={"star7"}
                          name={"writing"}
                          value="3"
                          radioGroup={"writing"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star7"}
                          title="Excellent"
                        />

                        <input
                          type="radio"
                          id={"star8"}
                          name={"writing"}
                          value="2"
                          radioGroup={"writing"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star8"}
                          title="Good"
                        />

                        <input
                          type="radio"
                          id={"star9"}
                          name={"writing"}
                          value="1"
                          radioGroup={"writing"}
                          onChange={this.onInputChange}
                        />
                        <label
                          className="full"
                          htmlFor={"star9"}
                          title="Fair"
                        />
                      </fieldset>
                    </center>
                  </div>
                  <div className="col-lg-1 flexMiddel">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addLanguagesData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table table-bordered qulification-table">
                        <thead className="table-light">
                          <tr>
                            <th className="align-middle">Language</th>
                            <th className="align-middle">Speaking</th>
                            <th className="align-middle">Reading</th>
                            <th className="align-middle">Writing</th>
                            <th width="50px" className="align-middle">
                              Remove
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.allLanguagesData.map(
                            (languages, index) => {
                              return (
                                languages.LanguageName !== undefined &&
                                  languages.LanguageName !== "",
                                languages.Speaking > 0 &&
                                languages.Reading > 0 &&
                                languages.Writing > 0 ? (
                                  <tr key={index}>
                                    <td className="align-middle">
                                      {languages.LanguageName}
                                    </td>
                                    <td className="align-middle">
                                      {(parseInt(languages.Speaking, 10) ===
                                        3 &&
                                        "Excellent") ||
                                        (parseInt(languages.Speaking, 10) ===
                                          2 &&
                                          "Good") ||
                                        (parseInt(languages.Speaking, 10) ===
                                          1 &&
                                          "Fair")}
                                    </td>
                                    <td className="align-middle">
                                      {(parseInt(languages.Reading, 10) === 3 &&
                                        "Excellent") ||
                                        (parseInt(languages.Reading, 10) ===
                                          2 &&
                                          "Good") ||
                                        (parseInt(languages.Reading, 10) ===
                                          1 &&
                                          "Fair")}
                                    </td>
                                    <td className="align-middle">
                                      {(parseInt(languages.Writing, 10) === 3 &&
                                        "Excellent") ||
                                        (parseInt(languages.Writing, 10) ===
                                          2 &&
                                          "Good") ||
                                        (parseInt(languages.Writing, 10) ===
                                          1 &&
                                          "Fair")}
                                    </td>
                                    <td className="text-center align-middle">
                                      <button
                                        className="btn btn-xs btn-danger theme-btn"
                                        onClick={this.languagesConfigDelete.bind(
                                          this,
                                          index
                                        )}
                                        type="button"
                                      >
                                        <i className="fa fa-trash" />
                                      </button>
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )
                              );
                            }
                          )}
                        </tbody>
                      </table>
                      {this.state.showErrLanguages && (
                        <span className="require_field mb-3">
                          Please Select Language
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.filter(
              i => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 13
            ).length > 0 && ( */}
            <div className="row">
              <div className="col-lg-12 ">
                <hr />
                <h4 className="page-title sub-title">Student Visa Details</h4>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>NRI Student?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isForeignStudent ? true : false}
                          name="isForeignStudent"
                          onChange={this.onSwitchForeignStudent}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                  {this.state.isForeignStudent === true && (
                    <div className="col-lg-12 mt-3">
                      <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Passport No</label>
                            <input
                              type="text"
                              className="form-control"
                              id="passportNo"
                              value={this.state.passportNo || ""}
                              name="passportNo"
                              label="Passport No"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Visa Details</label>
                            <input
                              type="text"
                              className="form-control"
                              id="visaDetails"
                              value={this.state.visaDetails || ""}
                              name="visaDetails"
                              label="Visa Details"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Issue Date</label>
                            <DatePicker
                              selected={this.state.issueDate}
                              onChange={this.issueDate}
                              showYearDropdown
                              showMonthDropdown
                              className="form-control"
                              dateFormat={this.props.systemConfig.DateFormat}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Expiry Date</label>
                            <DatePicker
                              selected={this.state.expiryDate}
                              onChange={this.expiryDate}
                              showYearDropdown
                              showMonthDropdown
                              className="form-control"
                              dateFormat={this.props.systemConfig.DateFormat}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Name Of Country</label>
                            <input
                              type="text"
                              className="form-control"
                              id="nameOfCountry"
                              value={this.state.nameOfCountry || ""}
                              name="nameOfCountry"
                              label="Name Of Country"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div className="form-group">
                            <label>Type of VISA</label>
                            <input
                              type="text"
                              className="form-control"
                              id="typeOfVISA"
                              value={this.state.typeOfVISA || ""}
                              name="typeOfVISA"
                              label="Type of VISA"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* )} */}

            {/* {this.props.admissionFormConfiguration.length > 0 && ( */}
            <div className="col col-lg-12 mt-3 row">
              <Button
                type="submit"
                className="btn btn-success btn-lg theme-btn"
              >
                <i className="fa fa-save" />
                Save
              </Button>
            </div>
            {/* )} */}
          </Form>
        </div>
      </div>
    );
  }
}
function mapStateToProps({
  auth,
  common,
  update,
  systemConfig,
  countryStateCity,
  userDetails,
  achievementList,
  profileLanguageList,
  achievementByStudent,
  // admissionFormConfiguration,
  languageKnownByStudent,
  admissionPhysicallychallenge,
  admissionConfiguration,
}) {
  return {
    auth,
    common,
    update,
    systemConfig,
    countryStateCity,
    userDetails,
    achievementList,
    profileLanguageList,
    achievementByStudent,
    // admissionFormConfiguration,
    languageKnownByStudent,
    admissionPhysicallychallenge,
    admissionConfiguration,
  };
}
export default connect(mapStateToProps, {
  clearUpdate,
  getCommonAll,
  getCountryStateCity,
  admissionPersonalInfoInsert,
  getUserDetailsByUserId,
  getAllAchievements,
  getAllProfileLanguages,
  // getAllAdmissionFormConfigurationByFormId,
  getAchievementsByStudentId,
  getLanguageknownsByStudentId,
  getAllPhysicallyChallengeCategory,
})(UserProfile);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/UserProfile.js